module.exports = {
  messages: {
    CN: {
      postModalTitle: '一键发布。试用期间解锁完整搜索权限。更快获取潜在客户！',
      postModalLabel1: '客户搜索列表',
      postModalLabel2: '自动添加好友',
      postModalLabel3: '看板',
      postModalIconTxt: '发布后',
      postModalAllBtn: '查看全文',
      postModalBtnTxt: '创建任务并分享post',
      postModalBtnTxt1: '仅创建任务',
      postModalLabelTxt: '不支持',
      postModalLabelTxt1: '全部支持',
      postModalLabelTxt2: '无限',
      successModalTitle: '分享权限已激活',
      successModalTxt: '任务已创建，Post已在 LinkedIn分享。您可以在活动详情页面查看完整的搜索结果。',
      postTitleBtnTxt: '继续分享',
      postTitleTxt: '分享Post，解锁客户搜索列表并自动添加他们，将提升潜在客户量300%！',
    },
    US: {
      postModalTitle: 'One-click posting. Full search access, even in trial. Get leads faster！',
      postModalLabel1: 'People search list',
      postModalLabel2: 'Connection request',
      postModalLabel3: 'Dashboard',
      postModalIconTxt: 'After posting',
      postModalAllBtn: 'View full content',
      postModalBtnTxt: 'Launch a campaign and share a post',
      postModalBtnTxt1: 'Only publish the campaign',
      postModalLabelTxt: 'Not supported',
      postModalLabelTxt1: 'Fully supported',
      postModalLabelTxt2: 'Unlimited',
      successModalTitle: 'The posting benefits have been activated.',
      successModalTxt: 'The campaign has been successfully published, and the post is live on LinkedIn. You can view the full search results on the campaign details page.',
      postTitleBtnTxt: 'Go ahead and post',
      postTitleTxt: 'Share a post and turn LinkedIn search results into leads: Build your connections and grow your lead volume up to 3x!',
    },
    AR: {
      postModalTitle: 'نشر بنقرة واحدة. وصول كامل للبحث حتى أثناء التجربة. احصل على العملاء المحتملين بشكل أسرع!',
      postModalLabel1: 'قائمة بحث الأشخاص',
      postModalLabel2: 'طلب الاتصال',
      postModalLabel3: 'لوحة التحكم',
      postModalIconTxt: 'بعد النشر',
      postModalAllBtn: 'عرض المحتوى الكامل',
      postModalBtnTxt: 'إطلاق حملة ومشاركة منشور',
      postModalBtnTxt1: 'نشر الحملة فقط',
      postModalLabelTxt: 'غير مدعومة',
      postModalLabelTxt1: 'مدعوم بالكامل',
      postModalLabelTxt2: 'غير محدودة',
      successModalTitle: 'تم تفعيل مزايا النشر.',
      successModalTxt: 'تم نشر الحملة بنجاح، والمنشور الآن مباشر على LinkedIn. يمكنك عرض نتائج البحث الكاملة على صفحة تفاصيل الحملة.',
      postTitleBtnTxt: 'تابع وقم بالنشر',
      postTitleTxt: ' شارك منشورًا وحوّل نتائج بحث LinkedIn إلى عملاء محتملين: قم بتوسيع شبكتك وزيادة حجم عملائك المحتملين بنسبة تصل إلى 3 أضعاف!',
    }
  }
}